export default "__VITE_ASSET__CvSHAXRU__"